// extracted by mini-css-extract-plugin
export var modal = "_e5-0";